// extracted by mini-css-extract-plugin
module.exports = {"location":"icon-row_location__KAAwa typography_bodyFont__ybYPk","pinIcon":"icon-row_pinIcon__v9O03"};